import React, { Component } from "react";

import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import WidgetModal from "./../../widget/WidgetModal";
import { message, Modal } from 'antd';
import moment from 'moment';
import { ExclamationCircleFilled } from '@ant-design/icons'
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';
import './index.css';

class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            optionsData: [],
            cityList: [],
            modelOptions: {
                type: 'message',
                title: '提示',
                index: 0,
                width: '760px',
                message: null,
                isNext: true,
                isOk: false,
                wrapClassName: 'sg-index-model',
                bodyStyle: { padding: 0 },
            },
            groupData: [
                {
                    value: 'true',
                    title: '是'
                }, {
                    value: 'false',
                    title: '否'
                }
            ],
            modal: null,
            modalSelect: null,
            isHide: true,
            flag: false,
            btnFlag: false,
            switchLocale: true,
            Provinca: [],
            Provincelist: [],
            backProvince: [],
            type: 0,
            nextNum: 0,
            activeIndex: -1,
            activesIndex: -1,
            region: '',
            isGiveService: 'true',
            countyCode: "",
            userInfo: {},
            defaultValue: [],
            pageInfo: {},
            settingInfo: {},
            tipsInfo: {},
            timeFlag: false,
            mapCity: [],
            hidenBtn: false,
            urlCode: '',
            urlName: ''
        }
        this.beforehandBtn = this.beforehandBtn.bind(this);
        this.onOk = this.onOk.bind(this);
        this.onOkClick = this.onOkClick.bind(this);
        this.onRadioChange = this.onRadioChange.bind(this);
        this.cityBtn = this.cityBtn.bind(this);
    }
    componentDidMount() {
        // 处理URL参数
        const paramsData = new URLSearchParams(window.location.search);
        const urlParams = JSON.parse(decodeURIComponent(paramsData.get('urlData') || '{}'))
        if (urlParams.urlArr) {
            localStorage.setItem('defaultValue', urlParams.urlArr)
        }
        if (urlParams.urlName) {
            localStorage.setItem('region', urlParams.urlName)
        }
        this.getUserInfo()
        if (!localStorage.getItem('ProvincialUrbanAreas') && !this.getSearchInfo('addressList')) {
            this.setState({
                switchLocale: false
            })
        }
        if (this.getSearchInfo('addressList')) {
            let defaultValue = this.getSearchInfo('addressList').split(',')
            this.setState({
                defaultValue: defaultValue.length === 3 ? defaultValue : [],
                switchLocale: defaultValue.length === 3
            })
        }
        if (localStorage.getItem('defaultValue')) {
            let defaultValue = localStorage.getItem('defaultValue').split(',')
            this.setState({
                defaultValue: defaultValue.length === 3 ? defaultValue : [],
                switchLocale: defaultValue.length === 3
            })
        }
        this.queryPartCity()
        // setTimeout(() => {
        // this.queryDimension("D111001", "", "", "")
        // })
    }
    getSearchInfo(name) {
        let info = this.props.location.search
        const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
        const r = info.substr(1).match(reg);
        if (r != null) return decodeURIComponent(r[2]); return null;
    }
    queryAuditMaxnewinfo() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/audit_maxnewinfo',
            params: {},
            callback: (data) => {
                if (data && data.status === 0) {
                    this.setState({
                        tipsInfo: data.result
                    })
                }
            }
        }, this);
    }
    getLoginToken() {
        this.queryAuditMaxnewinfo()
        // WidgetAjax.ajax({
        //     url: Config.getBasePath() + '/gradeIndividualAPI/Qrcode/getQridUrl',
        //     params: {},
        //     callback: (data) => {
        //         if (data && data.access) {
        //             this.queryAuditMaxnewinfo()
        //         }
        //     }
        // }, this);
    }
    getUserInfo() {
        let userInfo = sessionStorage.getItem("_user_info_")
        if (userInfo && userInfo != "undefined") {
            let info = JSON.parse(userInfo)
            this.setState({
                userInfo: info
            })
            this.getLoginToken();

        }
    }
    queryPartCity() {
        WidgetAjax.ajax({

            url: Config.getBasePath() + '/task/templist',
            params: {
                // dimension: obj,
                TYPE: 1,
                "UID": "S1000"
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    // let list = data.results[0].values.map(res=>{return res.value})
                    this.setState({
                        mapCity: data.results
                    })
                    this.queryDimension("D111001", "", "", "")
                }
            }
        }, this);
        // let obj = {
        //     code: 'D330',
        //     hierarchy: 3,
        // }
        // WidgetAjax.ajax({
        //     url: Config.getBasePath() + '/widget/dimension',
        //     params: {
        //         dimension: obj
        //     },
        //     callback: (data) => {
        //         if (data && data.status === 0) {
        //             let list = data.results[0].values.map(res=>{return res.value})
        //             this.setState({
        //                 mapCity: list
        //             })
        //             this.queryDimension("D111001", "", "", "")
        //         }
        //     }
        // }, this);
    }
    // /gradelndividualApl/widget/dimension
    queryDimension(type, filter, code, list) {
        const { mapCity } = this.state
        let obj = {
            code: type,
            hierarchy: 3,
        }
        let defaultValue = this.state.defaultValue || []
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/customdistrict/custom_district',
            params: {
                // code: type,
                // hierarchy: "3",
                dimension: obj
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    let nameList = mapCity.map(res => { return res.value })

                    let arr = data.results[0].values.filter(res => { return nameList.includes(res.value) })
                    if (nameList) {
                        arr.forEach((da, index) => {
                            let info = mapCity.find(res => { return res.value == da.value })
                            let item = mapCity.find(res => { return res.name == da.name })
                            da.label = da.name
                            da.link = item?.link
                            da.value = da.value.toString()
                            da.state = info.state
                            da.subdimension.values.forEach((res, num) => {
                                res.label = res.name
                                res.value = res.value.toString()
                                if (res.subdimension && res.subdimension.values.length) {
                                    res.subdimension.values.forEach((item, i) => {
                                        item.label = item.name
                                        item.value = item.value.toString()

                                    })
                                }
                                res.children = res.subdimension && res.subdimension.values ? res.subdimension.values : []
                            })
                            da.children = da.subdimension.values
                        })
                        // if (this.getSearchInfo('addressList')) {
                        //     defaultValue = this.getSearchInfo('addressList').split(',')
                        // }else {
                        //     let defaultValueStr = localStorage.getItem("defaultValue")
                        //     if(defaultValueStr){
                        //         defaultValue = defaultValueStr.split(',')
                        //     }
                        // }
                        localStorage.setItem("addressInfo", JSON.stringify(arr))
                        if (defaultValue && defaultValue.length > 0 && arr && arr.length) {
                            let info1 = arr.find(res => { return res.value === defaultValue[0] })

                            let info2 = info1?.children.find(res => { return res.value === defaultValue[1] })
                            // if(['500000', '110000', '120000', '310000'].includes(info1.value)){
                            //     info2 = info1
                            // }else{
                            //     info2 = info1.children.find(res=>{return res.value === defaultValue[1]})
                            // }
                            let info3 = info2?.children.find(res => { return res.value === defaultValue[2] })

                            this.setState({
                                optionsData: arr,
                                defaultValue: defaultValue,
                                region: info3 ? info3.name : '',
                                countyCode: info3 ? info3.value : '',
                                Provinca: [info1?.name, info2?.name, info3?.name]
                            })
                            this.queryInfo(info3.value)
                        } else {
                            this.setState({
                                optionsData: arr
                            })
                        }
                        return list
                    }



                }
            }
        }, this);
    }
    queryInfo(SSQXID) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/template/info',
            params: {
                SSQXID: SSQXID
            },
            callback: async (data) => {
                if (data && data.status === 0) {
                    localStorage.setItem("_template_info_", JSON.stringify(data.result))

                    await this.setState({
                        pageInfo: data.result,
                    })
                    if (!this.state.pageInfo.MBMS || !this.state.pageInfo.STARTTIME) {
                        this.setState({
                            timeFlag: false
                        })
                    }
                    if (new Date(this.state.pageInfo.STARTTIME).getTime() < new Date().getTime() && new Date(this.state.pageInfo.ENDTIME).getTime() > new Date().getTime()) {
                        this.setState({
                            timeFlag: true
                        })
                    } else {
                        this.setState({
                            timeFlag: false
                        })
                    }
                    this.switchLocales()
                } else {
                    localStorage.setItem("_template_info_", '')
                    this.setState({
                        pageInfo: {}
                    })
                }
            }
        }, this);
    }
    // onChange(value) {
    //     this.setState({
    //         defaultValue: value
    //     })
    //     localStorage.setItem("defaultValue", value[value.length - 1])
    //     this.queryInfo(value[value.length - 1])
    // };
    onOk(type) {
        if (this.state.settingInfo.STATE === '1' && this.state.settingInfo.SFSB === '0') {
            this.props.history.push({
                pathname: "/home/filling",
                state: {
                    isGiveService: this.state.isGiveService,
                    PROVINCE: this.state.defaultValue[0],
                    CITY: this.state.defaultValue[1],
                    COUNTY: this.state.defaultValue.length > 2 ? this.state.defaultValue[2] : ''
                }
            });
        } else if (this.state.modelOptions.okText === '我知道了') {
            this.props.history.push({ pathname: "/home/guide", state: { settingInfo: this.state.settingInfo } });
        }
        this.modal.onClose();
    }
    beforehandBtn() {
        const { userInfo } = this.state;
        let dateTime = moment().format('YYYY/MM/DD')
        let dateTimeNum = `${dateTime} 00:00:00`
        let endTimeNum = localStorage.getItem('endTime') + ' ' + '23:59:59'
        let startTimeNum = localStorage.getItem('startTime') + ' ' + '00:00:00'
        if (!userInfo.qrtype) {
            message.warning({
                content: '请登录后再试！',
                className: 'custom-class',
                duration: 2,
                onClose: () => {
                    this.props.history.push({ pathname: "/home/login", state: {} });
                }
            })
            return
        }
        if (new Date(startTimeNum).getTime() > new Date(dateTimeNum).getTime()) {
            message.warning('当前时间未到申报期开始时间，请等申报开始后再进行申报！');
            return
        }
        // if (new Date(dateTimeNum).getTime() > new Date(endTimeNum).getTime()) {
        //     message.warning('当前时间已过申报期结束时间！');
        //     return
        // }
        let defaultValue = ''
        if (localStorage.getItem('defaultValue')) {
            let arr = localStorage.getItem('defaultValue').split(',')
            if (arr.length === 3) {
                defaultValue = arr[2]
            }
        }
        // if (!pageInfo.TASKID) {
        //     message.warning('当前所选省份不在试点范围内，请联系总局申请开通！');
        //     return
        // }
        let modelOptions = this.state.modelOptions
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/businessSystem/setting',
            params: {
                SSQXID: defaultValue || localStorage.getItem('defaultValue')
            },
            callback: (data) => {
                console.log(data)
                if (data && data.status === 0) {
                    this.setState({
                        settingInfo: data.result
                    })
                    if (data.result.STATE === '0') {
                        modelOptions.isOk = true
                        modelOptions.backBtn = false
                        modelOptions.isNext = false
                        modelOptions.okText = '确认'
                        modelOptions.message = <div className="sg-index-body"><ExclamationCircleFilled style={{ color: '#E4B047' }} />&nbsp;&nbsp;您好，当前不在申报期，无申报任务，请在申报期内申报！</div>
                        this.modal.open();
                    }
                    else if (data.result.STATE === '10') {
                        modelOptions.isOk = true
                        modelOptions.backBtn = false
                        modelOptions.isNext = false
                        modelOptions.okText = '确认'
                        modelOptions.message = <div className="sg-index-body"><ExclamationCircleFilled style={{ color: '#E4B047' }} />&nbsp;&nbsp;您申报的个体工商户已被撤销认定，[{data.result.CXSJ}]后可再次申报。</div>
                        this.modal.open();
                    }
                    else if (data.result.SFSB === '9') {
                        modelOptions.isOk = true
                        modelOptions.backBtn = false
                        modelOptions.isNext = false
                        modelOptions.isCancel = false
                        modelOptions.okText = '我知道了'
                        modelOptions.wrapClassName = 'isNotIndividual'
                        modelOptions.message = <div className="sg-index-body"><ExclamationCircleFilled style={{ color: '#E4B047' }} />&nbsp;&nbsp;您已参与其他年度的申报并被评定成功，感谢您的参与！</div>
                        this.modal.open();
                    }
                    else if (data.result.SFSB === '1') {
                        this.props.history.push({ pathname: "/home/guide", state: { settingInfo: data.result } });
                    }
                    else if (data.result.STATE === '1' && data.result.SFSB === '0') {
                        let year = new Date(data.result.ND).getFullYear()
                        // eslint-disable-next-line
                        let reg = /(\d{4})\-(\d{2})\-(\d{2})/
                        modelOptions.title = '填报须知'
                        //确定
                        modelOptions.isOk = false
                        // 返回
                        modelOptions.backBtn = false
                        // 取消
                        modelOptions.isCancel = true
                        // 下一步
                        modelOptions.isNext = true
                        modelOptions.message = <div className="sg-index-bg sg-index-model">
                            <div className="sg-top-img">
                                <div className="sg-img-view">
                                    <img className='sg-bg-img' alt='#' src={require('../../img/business/modelBg.png')} />
                                    <div className="sg-view-center sd-middle">
                                        <div className="sg-center-li sd-start">
                                            <div className="sg-li-round sg-bg1">1</div>
                                            <div className="sg-li-font">填报须知</div>
                                        </div>
                                        <div className="sg-center-line"></div>
                                        <div className="sg-center-li sd-start">
                                            <div className="sg-li-round">2</div>
                                            <div className="sg-li-font">承诺声明</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="sg-bg-center">
                                <div className="sg-center-list">1.您当前进入的申报是<span style={{ color: '#357AC5' }}>{year}</span>年第一批次的全国“名特优新”个体工商户申报服务，申报期为<span style={{ color: '#357AC5' }}>{data.result.STARTTIME.replace(reg, "$1年$2月$3日")}</span>至<span style={{ color: '#357AC5' }}>{data.result.ENDTIME.replace(reg, "$1年$2月$3日")}</span>止，依据本省的申报要求不定期开启申报，请您关注相关日程安排，同时申报结果将在评定入库后向社会公示。</div>
                                <div className="sg-center-list">2.申报材料应真实反映个体工商户的实际情况，个体工商户对其公示信息的真实性、及时性负责。</div>
                                <div className="sg-center-list">3.本填报内容分为基本信息、分类标准、每项信息均需要进行填报；</div>
                                <div className="sg-center-list">4.个体工商户在申报期截止日前均可发起资料修改，系统在申报期截止后以最后一次提交材料为依据，未查询到提交记录，则认为未申报。</div>
                                <div className="sg-center-list">5.同一自然人在同一县级行政区域内设立多个个体工商户的，最多只能有一个个体工商户入库。</div>
                            </div>
                        </div>
                        this.setState({
                            modelOptions: modelOptions,
                            nextNum: 0
                        })
                        this.modal.open();
                    }
                } else {
                    message.warning(data.message);
                }
            }
        }, this);

    };
    /**
     * 把子组件注入到父主键里
     * @param {*} ref 
     */
    onRef = (ref) => {
        this.modal = ref;
    };
    onSelect = (ref) => {
        this.modalSelect = ref;
    }
    onRadioChange(val) {
        this.setState({
            isGiveService: val === 'true',
        })
    };
    onOkClick(type) {
        let modelOptions = this.state.modelOptions
        let num = this.state.nextNum
        type === 'isNext' ? num++ : num--
        let year = new Date(this.state.settingInfo.STARTTIME).getFullYear()
        // eslint-disable-next-line
        let reg = /(\d{4})\-(\d{2})\-(\d{2})/
        if (num === 0) {
            // 取消
            modelOptions.isCancel = true
            // 返回
            modelOptions.backBtn = false
            // 确定
            modelOptions.isOk = false
            modelOptions.width = '760px'
            modelOptions.title = '填报须知'
            modelOptions.nextText = '下一步'
            modelOptions.message = <div className="sg-index-bg sg-index-model">
                <div className="sg-top-img">
                    <div className="sg-img-view">
                        <img className='sg-bg-img' alt='#' src={require('../../img/business/modelBg.png')} />
                        <div className="sg-view-center sd-middle">
                            <div className="sg-center-li sd-start">
                                <div className="sg-li-round sg-bg1">1</div>
                                <div className="sg-li-font">填报须知</div>
                            </div>
                            <div className="sg-center-line"></div>
                            <div className="sg-center-li sd-start">
                                <div className="sg-li-round">2</div>
                                <div className="sg-li-font">承诺声明</div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="sg-bg-center">
                    <div className="sg-center-list">1.您当前进入的申报是<span style={{ color: '#357AC5' }}>{year}</span>年第一批次的全国“名特优新”个体工商户申报服务，申报期为<span style={{ color: '#357AC5' }}>{this.state.settingInfo.STARTTIME.replace(reg, "$1年$2月$3日")}</span>至<span style={{ color: '#357AC5' }}>{this.state.settingInfo.ENDTIME.replace(reg, "$1年$2月$3日")}</span>止，申报时间依据本省的要求，不定期开启申报任务，请您关注相关日程安排，同时申报结果次年会向社会公示时使用。</div>
                    <div className="sg-center-list">2.申报材料应真实反映个体工商户的实际情况，个体工商户对其公示信息的真实性、及时性负责。</div>
                    <div className="sg-center-list">3.本填报内容分为基本信息、分类标准、每项信息均需要进行填报；</div>
                    <div className="sg-center-list">4.个体工商户在申报期截止日前均可发起资料修改，系统在申报期截止后以最后一次提交材料为依据，未查询到提交记录，则认为未申报。</div>
                    <div className="sg-center-list">5.同一自然人在同一县级行政区域内设立多个个体工商户的，最多只能有一个个体工商户入库。</div>
                </div>
            </div>
        } else if (num === 1) {
            this.modal.getPhoneCode()
            modelOptions.title = '填报须知'
            modelOptions.width = '760px'
            modelOptions.nextText = '同意'
            modelOptions.message = <div className="sg-index-bg sg-index-model">
                <div className="sg-top-img">
                    <div className="sg-img-view">
                        <img className='sg-bg-img' alt='#' src={require('../../img/business/modelBg.png')} />
                        <div className="sg-view-center sd-middle">
                            <div className="sg-center-li sd-start">
                                <div className="sg-li-round sg-bg1">1</div>
                                <div className="sg-li-font">填报须知</div>
                            </div>
                            <div className="sg-center-line sg-bg1"></div>
                            <div className="sg-center-li sd-start">
                                <div className="sg-li-round sg-bg1">2</div>
                                <div className="sg-li-font">承诺声明</div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="sg-bg-center">
                    <div className="sg-center-list">1.我承诺填报的信息均为实际情况，保证信息的真实性、及时性、准确性等。</div>
                    <div className="sg-center-list">2.我承诺申报的个体工商户无行政处罚、无被列为失信人、无经营异常等情况。</div>
                    <div className="sg-center-list">3.我承诺填写的信息及材料证明文件真实有效，一旦发现申报虚假材料所造成的后果自行承担。</div>
                    <div className="sg-center-list">4.我同意将我申报的材料，认定成功后向社会公示使用。</div>
                </div>
            </div>
            modelOptions.isCancel = true
            modelOptions.isOk = false
            modelOptions.backBtn = true
            modelOptions.isNext = true


            // modelOptions.backBtn = true
            // modelOptions.isNext = false
            // modelOptions.isOk = true
        } else {
            this.onOk()
        }
        this.setState({
            modelOptions: modelOptions,
            nextNum: num
        })
        this.modal.open();
    }
    // goGuide() {
    //     const { userInfo } = this.state;
    //     // 判断有没有登录
    //     if (!userInfo.qrtype) {
    //         message.warning({
    //             content: '请登录后再试！',
    //             className: 'custom-class',
    //             duration: 2,
    //             onClose: () => {
    //                 this.props.history.push({ pathname: "/home/login", state: {} });
    //             }
    //         })
    //         return
    //     } else {
    //         this.props.history.push({ pathname: "/home/guide", state: {} });
    //     }

    // }
    goNotice() {
        const { userInfo } = this.state;
        if (!userInfo.qrtype) {
            message.warning('请登录后再试！');
            return
        } else {
            this.props.history.push({ pathname: "/home/notice", state: {} });
        }
    }
    Popup(item, index) {
        if(item && item.link) return window.open(item.link)
        if (item.state == 0) {
            message.warning('当前地区未开启申报窗口！');
            return
        }
        // if(['500000','110000','120000','310000'].includes(item.value)){
        //     this.setState({
        //         flag: true,
        //         activeIndex:index,
        //         Provinca: [item.name,item.name,''],
        //         backProvince: item.children,
        //         Provincelist: item.children,
        //         defaultValue: [item.value,item.value,''],
        //     })
        // }else{
        //     this.setState({
        //         flag: true,
        //         activeIndex:index,
        //         Provinca: [item.name],
        //         backProvince: item.children,
        //         Provincelist: item.children,
        //         defaultValue: [item.value],
        //     })
        // }
        this.setState({
            flag: true,
            activeIndex: index,
            Provinca: [item.name],
            backProvince: item.children,
            Provincelist: item.children,
            defaultValue: [item.value],
        })

    }
    cityBtn(item, index) {
        let list = this.state.Provinca
        let defaultValue = this.state.defaultValue

        if (list && list.length === 1) {
            list.push(item.name, '')
        } else {
            let listIndex = list.length - 1
            list.splice(listIndex, 1, item.name)
        }
        if (defaultValue && defaultValue.length === 1) {
            defaultValue.push(item.value, '')
        } else {
            let defaultValueIndex = defaultValue.length - 1
            defaultValue.splice(defaultValueIndex, 1, item.value)
        }
        if (item.children && item.children.length > 0) {
            this.setState({
                Provincelist: item.children,
                btnFlag: true,
                hidenBtn: false
            })
        } else {
            this.setState({
                region: item.name,
                countyCode: item.value,
                btnFlag: true,
                hidenBtn: true
            })
        }

    }
    goback() {
        let list = this.state.Provinca
        let defaultValue = this.state.defaultValue
        list.splice(1, 2)
        defaultValue.splice(1, 2)
        this.setState({
            btnFlag: false,
            Provincelist: this.state.backProvince,
            Provinca: list,
            defaultValue: defaultValue

        })
    }
    switch() {

        this.setState({
            switchLocale: false,
            flag: false,
            btnFlag: false,
            activeIndex: -1,
            activesIndex: -1,
            Provinca: [],

        })
    }
    switchLocales() {
        const { pageInfo, timeFlag, defaultValue, region } = this.state;
        this.setState({
            switchLocale: true,
        })
        if (!pageInfo.STARTTIME) {
            this.setState({
                timeFlag: false
            })
        }
        localStorage.setItem("ProvincialUrbanAreas", this.state.Provinca)
        localStorage.setItem("mbms", pageInfo.MBMS)
        localStorage.setItem("startTime", pageInfo.STARTTIME)
        localStorage.setItem("endTime", pageInfo.ENDTIME)
        localStorage.setItem('timeFlag', timeFlag)
        localStorage.setItem('defaultValue', defaultValue)
        localStorage.setItem('region', region)
    }
    closeModal() {
        this.setState({
            flag: false,
            btnFlag: false,
            activesIndex: -1,
            Provinca: [],

        })
    }
    render() {
        const { region, hidenBtn, activeIndex, switchLocale, btnFlag, Provinca, Provincelist, flag, optionsData, modelOptions, isHide, defaultValue, pageInfo } = this.state;
        console.log(optionsData, 'optionsData');
        return (
            <div data-component="index">
                {/* <div className="sg-index sd-columnBetween">
                    <div className="sg-index-top sd-middle">
                        <img className='sg-top-img' alt='#' src={require('../../img/business/font.png')} />
                    </div>
                    <div className="sg-index-banner">
                        <img className='sg-banner-img' alt='#' src={require('../../img/business/indexBanner.png')} />
                    </div>
                    <div className="sg-index-notice sd-spaceBetween">
                        <div className="sg-notice-left sd-start">
                            <img className='sg-left-img' alt='#' src={require('../../img/business/indexNotice.png')} />
                            <span className="sg-left-font" style={{display: !userInfo.qrtype||!year?'none':'inline-block'}}>{year}年度第一批申报{tipsInfo.HJMC}{tipsInfo.BLJG}，{tipsInfo.BLYJ}</span>
                            <span className="sg-left-font" style={{display: userInfo.qrtype&&!year?'inline-block':'none'}}>暂无信息通知！</span>
                            <span className="sg-left-font" style={{display: !userInfo.qrtype?'inline-block':'none'}}>您还未登录系统，请点击<Link to="/home/login" style={{textDecoration:'underline',color:'#357AC5'}}>登录</Link>后再试！</span>
                        </div>
                        <div className="sg-notice-right sd-end" onClick={()=>{this.goNotice()}}>
                            <span className="sg-right-font">更多</span>
                            <img className='sg-right-img' alt='#' src={require('../../img/business/indexRight.svg')} />
                        </div>
                    </div>
                    <div className="sg-index-center sd-spaceBetween">
                        <div className="sg-center-left">
                            <div className="sg-left-top sd-spaceBetween">
                                <div className="sg-top-font">申报综述</div>
                                <div className="sg-top-right" key={defaultValue.join(',')}>
                                    <WidgetCascaderSelect className="sg-right-select" onRef={this.onSelect} defaultValue={defaultValue} options={optionsData} data={optionsData} onSelect={(e)=>{this.onChange(e)}}/>
                                </div>
                            </div>
                            <div className="sg-left-center">
                             
                            </div>
                        </div>
                        <div className="sg-center-right">
                            <div className="sg-left-top sd-spaceBetween">
                                <div className="sg-top-font">用户服务</div>
                            </div>
                            <div className="sg-left-center sd-middle">
                                <div className="sg-center-li sd-columnCenter" onClick={this.beforehandBtn}>
                                    <div className="sg-li-view">
                                        <img className='sg-li-img' alt='#' src={require('../../img/business/indexIcon1.png')} />
                                    </div>
                                    
                                    <span className="sg-li-font">申报入口</span>
                                </div>
                                <div className="sg-center-li sd-columnCenter sg-color1 sg-ml60" onClick={()=>{this.goGuide()}}>
                                    <div className={`sg-li-view ${tipsInfo.HJMC?'sg-li-label':''}`}>
                                        <img className='sg-li-img' alt='#' src={require('../../img/business/indexIcon2.png')} />
                                    </div>
                                    
                                    <span className="sg-li-font">申报历史</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <img className='sg-bg-img' alt='#' src={require('../../img/index/backgroundTop.png')} />
                <div className="sg-index-background">
                    {
                        switchLocale ? <div className="sg-index-two">
                            <div className="sg-top-two">
                                <div className="sg-topLeft-two">
                                    <div className="sg-title-two sd-spaceBetween">
                                        <div className="sg-titleTop-two">
                                            <img className='sg-reportImg-two' alt='#' src={require('../../img/index/reportIcon.png')} />
                                            <div>申报综述</div>
                                        </div>
                                        <div className="sd-end">
                                            <div className="sg-titlesTop-two">
                                                <img className='sg-reportImg-two' alt='#' src={require('../../img/index/position.png')} />
                                                <div>当前：<span>{region || localStorage.getItem('region')}</span></div>
                                            </div>
                                            <div className="switch-locale-tow" onClick={() => { this.switch() }}>切换地区</div>
                                        </div>

                                    </div>
                                    <div className="sg-titleBottom-two">
                                        <img className='sg-leftImg-two' alt='#' src={require('../../img/index/leftimg.png')} />
                                        <img className='sg-rightImg-two' alt='#' src={require('../../img/index/rightimg.png')} />
                                        <div className="sg-center-main">
                                            {/* <div className="sg-titleH-two sd-middle">关于{localStorage.getItem('region')}个体工商户名特优新申报的通知</div> */}
                                            <div className="sg-mainText-two">
                                                <Center pageInfo={pageInfo} defaultValue={defaultValue} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="sg-topRight-two">
                                    <div className="topRight-top-two">
                                        <div className="sg-title-two">
                                            <div className="sg-titleTop-two">
                                                <img className='sg-reportImg-two' alt='#' src={require('../../img/index/reportIcon.png')} />
                                                <div>申报服务</div>
                                            </div>
                                        </div>

                                        {
                                            localStorage.getItem('startTime') !== 'undefined'
                                                ? <div className="sg-rightBottom-two">
                                                    <div className="sg-rightTime-two">开始时间:{pageInfo.STARTTIME || localStorage.getItem('startTime')}</div>
                                                    <div className="sg-rightTime-two">结束时间:{pageInfo.ENDTIME || localStorage.getItem('endTime')}</div>
                                                    <div className="sg-goLogin-two" onClick={() => { this.beforehandBtn() }}>我要申报</div>
                                                </div> : <div> <div className="sg-rightTitle-two">当前地区申报窗口</div>
                                                    <div className="sg-rightNoTime-two">未开启</div></div>
                                        }



                                        {/*  */}


                                    </div>
                                    <img className='sg-rightBackground-two' alt='#' src={require('../../img/index/rightBackground.png')} />

                                </div>
                            </div>

                            <div className="sg-bottom-two">

                                <div className="sg-title-two">

                                    <div className="sg-titleTop-two">
                                        <img className='sg-reportImg-two' alt='#' src={require('../../img/index/processIcon.png')} />
                                        <div>申报流程</div>
                                    </div>
                                </div>
                                <div className="sg-bottomBottom-two">
                                    <div className="sg-btmDl-two">
                                        <img alt='#' src={require('../../img/index/county.png')} />
                                        <div>选择所在区县</div>
                                    </div>
                                    <img className="sg-rightHead-two" alt='#' src={require('../../img/index/righthead.png')} />
                                    {/* <div className="sg-btmDl-two">
                                            <img alt='#' src={require('../../img/index/qualification.png')} />
                                            <div>查询申报资格</div>
                                        </div>
                                        <img className="sg-rightHead-two" alt='#' src={require('../../img/index/righthead.png')} /> */}
                                    <div className="sg-btmDl-two">
                                        <img alt='#' src={require('../../img/index/countyLogin.png')} />
                                        <div>电子营业执照登录</div>
                                    </div>
                                    <img className="sg-rightHead-two" alt='#' src={require('../../img/index/righthead.png')} />
                                    <div className="sg-btmDl-two">
                                        <img alt='#' src={require('../../img/index/material.png')} />
                                        <div>提交申报材料</div>
                                    </div>
                                    <img className="sg-rightHead-two" alt='#' src={require('../../img/index/righthead.png')} />
                                    <div className="sg-btmDl-two">
                                        <img alt='#' src={require('../../img/index/examine.png')} />
                                        <div>主管部门审核</div>
                                    </div>
                                    <img className="sg-rightHead-two" alt='#' src={require('../../img/index/righthead.png')} />
                                    <div className="sg-btmDl-two">
                                        <img alt='#' src={require('../../img/index/publicity.png')} />
                                        <div>结果公示</div>
                                    </div>
                                    <img className="sg-rightHead-two" alt='#' src={require('../../img/index/righthead.png')} />
                                    <div className="sg-btmDl-two">
                                        <img alt='#' src={require('../../img/index/warehousing.png')} />
                                        <div>入库</div>
                                    </div>
                                </div>
                            </div>

                        </div>

                            : <div className="sg-index">
                                <div className="sg-index-top">
                                    <div className="sg-index-title">
                                        “名特优新”个体工商户申报工作正式启动
                                        <img className='sg-left-img' alt='#' src={require('../../img/index/leftimg.png')} />
                                        <img className='sg-hr-img' alt='#' src={require('../../img/index/hr.png')} />
                                        <img className='sg-right-img' alt='#' src={require('../../img/index/rightimg.png')} />

                                    </div>
                                    <div className="sg-index-main">
                                        <div>为贯彻落实国务院《促进个体工商户发展条例》及《市场监管总局办公厅关于在部分地区先行先试推进个体工商户分型分类精准帮扶的通知》（市监注发〔2023〕28号），进一步推进全国个体工商户分型分类精准帮扶工作，提升个体工商户长期整体发展质量，现开展个体工商户“名特优新”申报评定工作，广大符合条件要求的个体工商户可以选择所在地区积极报名。</div>
                                    </div>
                                </div>
                                <div className="sg-index-bottom">
                                    <div className="sg-index-text">
                                        地方申报窗口
                                    </div>
                                    <div className="sg-index-tips">仅可进入开启申报的地方申报窗口</div>
                                    <div className="sg-index-center">
                                        {
                                            optionsData.map((item, index) => {
                                                return <div className={activeIndex === index ? "sg-index-active" : ""} style={{ background: item.state == 0 ? '#d8d8d8' : '', cursor: item.state == 0 ? 'no-drop' : '' }} onClick={() => { this.Popup(item, index) }} key={index}>{item.name}</div>
                                            })
                                        }
                                    </div>
                                </div>
                                <Modal
                                    open={flag}
                                    // title="Title"
                                    // onOk={handleOk}
                                    // onCancel={handleCancel}
                                    width={720}
                                    footer={null}
                                    closable={false}
                                    bodyStyle={{ width: "720px", padding: "30px 66px", height: "auto", background: "linear-gradient(180deg, #FFFFFF 0%, #E3F0FD 100%)", boxShadow: "box-shadow: 0px 9px 25px 0px rgba(0,0,0,0.25)", borderRadius: "8px" }}
                                // className="sg-modal-box"
                                >
                                    <img className="sg-modal-closeimg" onClick={() => { this.closeModal() }} alt='#' src={require('../../img/index/close.png')} />
                                    <div className="sg-modal-title">请选择您申报个体工商户的注册登记地区</div>
                                    <div className="sg-modal-hr"></div>
                                    <div className="sg-modal-top">
                                        <img className="sg-modal-img" alt='#' src={require('../../img/index/right.png')} />
                                        <div className="sg-modal-font">{Provinca.map((item, index) => {
                                            if (index === 0 || index === '0') {
                                                return <span key={index}>{item}</span>
                                            } else {
                                                return <span key={index} >
                                                    <img className="sg-modal-imgs" alt='#' src={require('../../img/index/righthead.png')} />
                                                    {item}</span>
                                            }
                                        })}</div>
                                    </div>
                                    <div className="sg-modal-center sd-spaceBetween  33">
                                        {
                                            Provincelist.map((item, index) => {
                                                if (item.children && item.children.length > 0) {
                                                    if (item.ISOPEN === 'N') {
                                                        return <></>
                                                    } else {
                                                        return <div className={Provinca.includes(item.name) ? "sg-modal-centerBox sg-modal-active" : "sg-modal-centerBox"} key={index} onClick={() => { this.cityBtn(item, index) }}>
                                                            {
                                                                item.name
                                                            }
                                                        </div>
                                                    }

                                                } else {
                                                    if (item.ISOPEN === 'Y') {
                                                        return <div className={Provinca.includes(item.name) ? "sg-modal-centerBox sg-modal-active" : "sg-modal-centerBox"} key={index} onClick={() => { this.cityBtn(item, index) }}>
                                                            {
                                                                item.name
                                                            }
                                                        </div>
                                                    }
                                                }


                                            })
                                        }
                                        <div className="sg-modal-centerBox2"></div>
                                        <div className="sg-modal-centerBox2"></div>
                                        <div className="sg-modal-centerBox2"></div>
                                        <div className="sg-modal-centerBox2"></div>
                                        <div className="sg-modal-centerBox2"></div>
                                    </div>
                                    <div className="sg-modal-bottom">仅显示可进入和开启申报的地区</div>
                                    {
                                        btnFlag ? <div className="sg-modal-bottombtn sd-middle">
                                            <div className="sg-modal-btnOne" style={{ marginLeft: hidenBtn ? '0' : '0' }} onClick={() => { this.goback() }}>返回上一级</div>
                                            <div className="sg-modal-bonTwo" style={{ display: hidenBtn ? 'block' : 'none' }} onClick={() => { this.queryInfo(this.state.countyCode) }}>进入地方申报窗口</div>
                                        </div> : ""
                                    }
                                </Modal>
                            </div>
                    }

                    <WidgetModal options={modelOptions} onRef={this.onRef} isHide={isHide} onOk={this.onOk} onOkClick={this.onOkClick}></WidgetModal>
                </div>
                <img className='sg-bgx-img' alt='#' src={require('../../img/index/backgroundBottom.png')} />

            </div>
        )
    }
}

export default Index

export const Center = ({ pageInfo, defaultValue, timeFlag }) => {
    // localStorage.setItem('mbms',pageInfo.MBMS)
    if (localStorage.getItem('mbms') !== 'undefined' || pageInfo.MBMS) {
        return (
            <div key={pageInfo.ZXDH}>
                <div className="sg-center-tips" dangerouslySetInnerHTML={{ __html: pageInfo.MBMS || localStorage.getItem('mbms') }}></div>
                {/* <div className="sg-center-font" style={{ display: pageInfo.ZXDH ? 'block' : 'none' }}>咨询电话：{pageInfo.ZXDH}</div> */}

            </div>
        )
    }
    else {
        return (
            <div className="sg-center-defined sd-columnCenter">
                <img className='sg-middle-img' alt='#' src={require('../../img/business/defined.png')} />
                <div className="sg-middle-font">{!pageInfo.MBMS && defaultValue && defaultValue.length ? '当前所选省份不在试点范围内，请联系总局申请开通' : '请先选择区县'}</div>
            </div>
        );
    }
}
